module.exports = __webpack_public_path__ + "img/20.6139d8e2.png";